export default "__VITE_ASSET__d8c0d516__"